<template>
  <div :class="$style.container">
    <div :class="$style.section">
      <div :class="$style.row">
        <div :class="$style.left">{{ $t('deal.payment.id') }}</div>
        <div :class="[$style.right, $style.colorGreen]">
          {{ paymentData.id }}
        </div>
      </div>
      <div :class="$style.row">
        <div :class="$style.left">{{ $t('deal.payment.date') }}</div>
        <div :class="$style.right">{{ displayPaymentDate }}</div>
      </div>
      <div :class="$style.row">
        <div :class="$style.left">{{ $t('deal.payment.amount') }}</div>
        <div :class="$style.right">{{ displayPaymentAmount }}</div>
      </div>
      <div :class="$style.row">
        <div :class="$style.left">{{ $t('deal.status') }}</div>
        <div :class="$style.right" :style="{ color: getColorByStatus }">
          {{ $t(displayStatus) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatAmount } from 'lib/utils/amount';
import { formatDateToCustomDate } from 'lib/utils/date';

const COLORS_MAP = {
  OPENED: 'rgba(33, 33, 33, 1)',
  CHALLENGE_PROCESSING: 'rgba(255, 81, 114, 1)',
  CHALLENGE_SUCCESS: 'rgba(255, 81, 114, 1)',
};

const STATUS_MAP = {
  OPENED: 'deal.status.opened',
  CHALLENGE_PROCESSING: 'deal.status.challenge.processing',
  CHALLENGE_SUCCESS: 'deal.status.challenge.success',
};

export default {
  name: 'DealInformation',
  props: {
    dealStatus: {
      type: String,
      required: true,
    },
    paymentData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    displayPaymentDate() {
      return formatDateToCustomDate(this.paymentData.date, 'DD.MM.YYYY');
    },
    displayPaymentAmount() {
      return formatAmount(this.paymentData.amount, this.paymentData.currency);
    },
    getColorByStatus() {
      return COLORS_MAP[this.dealStatus];
    },
    displayStatus() {
      return STATUS_MAP[this.dealStatus];
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +base-card
    padding: 18px 20px

    +respond-to('medium')
      padding: 20px

  .section
    display: flex
    flex-direction: column
    font-weight: 400
    font-size: 12px
    line-height: 17px

  .row
    display: flex

    &:not(:last-child)
      margin-bottom: 15px

  .left
    width: 60%
    color: rgba(33, 33, 33, 0.75)

  .right
    width: 40%
    color: rgba(33, 33, 33, 1)

  .colorGreen
    color: $color-green
</style>
